<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="名称" class="title" placeholder="请输入名称">
        <el-input v-model="keywordData.name_keyword"></el-input>
      </el-form-item>
      <el-form-item label="地域" class="address">
        <el-cascader
          :options="addressList"
          @change="saveAddress($event)"
          clearable
        >
          <template slot-scope="{ node, data }">
            <span
              >{{ data.label != "无" ? data.label : data.children.value }}
            </span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="WUPEN联盟" class="is-wupen">
        <el-select
          v-model="keywordData.wupen_flag"
          clearable
          placeholder="联盟"
        >
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="标签" class="tag">
        <keywordsinput
          :maxLen="18"
          v-model="keywordData.tags_keywords"
        ></keywordsinput>
      </el-form-item>

      <el-form-item label="状态" placeholder="状态" clearable class="status">
        <el-select v-model="keywordData.status" clearable placeholder="状态">
          <el-option label="无效" value="0"></el-option>
          <el-option label="有效" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>



<script>
import { getUniversityAddress_Api } from "@/apis/university.api";
export default {
  data() {
    return {
      keywordData: {
        name_keyword: "",
        tags_keywords: [],
        wupen_flag: "",
        status: "",
        city: "",
      },
      addressList: [],
    };
  },
  mounted() {
    this.getAddress();
  },
  methods: {
    saveAddress(tagData) {
      console.log(tagData);
      this.keywordData.continent = tagData[0];
      this.keywordData.country = tagData[1];
      this.keywordData.city = tagData[3];
    },
    getAddress() {
      getUniversityAddress_Api().then((res) => {
        this.addressList = res.data;
        console.log(this.addressList);
      });
    },
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
  .tag {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .title {
    width: 400px;
  }
  .address {
    width: 350px;
    /deep/ .el-cascader {
      width: 100%;
    }
  }
  .is-wupen {
    width: 200px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/components/UniversitySearch.vue